<div #titleElement mat-dialog-title class="pe-2">
  <button type="button" mat-icon-button mat-dialog-close>
    <ft-icon name="arrow-left" class="ft-icon--2" />
  </button>
  <div class="flex-grow-1" i18n>Offer</div>
  @let simulationEntity = simulation();
  @if (simulationEntity && (simulation()?.operationNumber || simulation()?.operation?.number)) {
    <button
      type="button"
      mat-icon-button
      i18n-title
      title="More options"
      [matMenuTriggerFor]="optionsMenu">
      <ft-icon name="ellipsis-vertical" class="ft-icon--2" />
    </button>
    <mat-menu #optionsMenu="matMenu">
      @for (
        group of simulationService.getContextActions(simulationEntity);
        track group.id
      ) {
        @if ($index > 0) {
          <hr class="my-2" />
        }
        @for (action of group.children; track action.id) {
          <button type="button" mat-menu-item (click)="action.click()">
            {{ action.label }}
          </button>
        }
      }
    </mat-menu>
  }
</div>
<div #contentElement mat-dialog-content class="pt-0 px-4 px-md-5">
  <div
    class="ft-observe-interseting"
    (ftObserveIntersecting)="
      appService.setOverlapped($event, titleElement)
    "></div>
  @if (!isBeneficiary()) {
    <div
      class="ft-card ft-card--primary flex-grow-1"
      style="position: sticky; left: 0">
      <div class="ft-card__body ft-card__body--primary">
        <div class="d-flex flex-column flex-md-row gap-3">
          <div class="ft-data-field">
            <div class="ft-data-field__label" i18n>Interest to be earned</div>
            <div
              class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
              style="font-size: var(--ft-display-font-size-lg)">
              <div>{{ simulation()?.interestEarned | number }}</div>
              <div class="ft-suffix ft-suffix--sm">{{ currencyId() }}</div>
              <ft-icon
                name="information"
                class="text-white ft-icon--1 ms-1"
                #totalTooltip="matTooltip"
                (click)="totalTooltip.toggle()"
                i18n-matTooltip
                [matTooltip]="
                  totalToReceive +
                  ' ' +
                  ((simulation()?.amount || 0) +
                    (simulation()?.interestEarned || 0) | number)
                " />
            </div>
          </div>
        </div>
      </div>
      <div class="ft-card__body ft-card__body--secondary">
        <div class="d-flex gap-3">
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Amount</div>
            <div class="ft-data-field__value">
              {{ simulation()?.amount | number }}
            </div>
          </div>
          <div class="ft-separator"></div>
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Term</div>
            <div class="ft-data-field__value">
              {{ simulation()?.term }}
              {{ simulation()?.frequency?.description }}
            </div>
          </div>
          <div class="ft-separator"></div>
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Rate</div>
            <div class="ft-data-field__value">{{ simulation()?.rate }}%</div>
          </div>
        </div>
      </div>
    </div>
    <h3
      class="d-flex align-items-center gap-2"
      style="position: sticky; left: 0">
      <div i18n>Beneficiary data</div>
    </h3>
    <div class="ft-table__wrapper" style="position: sticky; left: 0">
      <table class="ft-table">
        <tbody>
          <tr>
            <th class="text-start" i18n>Alias</th>
            <td>{{ simulation()?.beneficiary?.alias }}</td>
          </tr>
          <tr>
            <th class="text-start" i18n>Email</th>
            <td>{{ simulation()?.beneficiary?.email }}</td>
          </tr>
          <tr isGranted="dwl-group">
            <th class="text-start" i18n>Group</th>
            <td>{{ simulation()?.group?.description || 'N/A' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h3
      class="d-flex align-items-center gap-2"
      style="position: sticky; left: 0">
      <div i18n>General information</div>
    </h3>
    <div
      class="ft-card"
      style="width: fit-content; min-width: 100%"
      style="position: sticky; left: 0">
      <table class="ft-table">
        <tbody>
          <tr>
            <th class="text-start" i18n>Amortization table type</th>
            <td>{{ simulation()?.tableType?.description }}</td>
          </tr>
          <tr>
            <th class="text-start" i18n>Start date</th>
            <td>{{ simulation()?.effectiveDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <th class="text-start" i18n>Pay starting from</th>
            <td>{{ simulation()?.firstPaymentDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
          <tr>
            <th class="text-start" i18n>Expiration date</th>
            <td>{{ simulation()?.expirationDate | date: 'dd/MM/yyyy' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  } @else {
    <div
      class="ft-card ft-card--primary flex-grow-1"
      style="position: sticky; left: 0">
      <div class="ft-card__body ft-card__body--primary">
        <div class="d-flex flex-column flex-md-row gap-3">
          <div class="ft-data-field">
            <div class="ft-data-field__label" i18n>Installment</div>
            <div
              class="ft-data-field__value d-flex align-items-center justify-content-center gap-1"
              style="font-size: var(--ft-display-font-size-lg)">
              <div>
                {{ simulation()?.operation?.installment?.amount | number }}
              </div>
              <div class="ft-suffix ft-suffix--sm">{{ currencyId() }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="ft-card__body ft-card__body--secondary">
        <div class="d-flex gap-3">
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Amount</div>
            <div class="ft-data-field__value">
              {{ simulation()?.operation?.amount | number }}
            </div>
          </div>
          <div class="ft-separator"></div>
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Term</div>
            <div class="ft-data-field__value">
              {{ simulation()?.operation?.term }}
              {{ simulation()?.operation?.frequency?.description }}
            </div>
          </div>
          <div class="ft-separator"></div>
          <div class="ft-data-field flex-grow-1">
            <div class="ft-data-field__label" i18n>Rate</div>
            <div class="ft-data-field__value">
              {{ simulation()?.operation?.rate }}%
            </div>
          </div>
        </div>
      </div>
    </div>
    <h3
      class="d-flex align-items-center gap-2"
      style="position: sticky; left: 0">
      <div i18n>Investor</div>
    </h3>
    <div class="ft-table__wrapper" style="position: sticky; left: 0">
      <table class="ft-table">
        <tbody>
          <tr>
            <th class="text-start" i18n>Alias</th>
            <td>{{ simulation()?.lender?.alias }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h3
      class="d-flex align-items-center gap-2"
      style="position: sticky; left: 0">
      <div i18n>General information</div>
    </h3>
    <div
      class="ft-card"
      style="width: fit-content; min-width: 100%"
      style="position: sticky; left: 0">
      <table class="ft-table">
        <tbody>
          <tr>
            <th class="text-start" i18n>Amortization table type</th>
            <td>
              {{ simulation()?.operation?.amortizationTable?.description }}
            </td>
          </tr>
          <tr>
            <th class="text-start" i18n>Start date</th>
            <td>
              {{ simulation()?.operation?.startDate | date: 'dd/MM/yyyy' }}
            </td>
          </tr>
          <tr>
            <th class="text-start" i18n>Pay starting from</th>
            <td>
              {{ simulation()?.operation?.installment?.firstInstallmentPaymentDate | date: 'dd/MM/yyyy' }}
            </td>
          </tr>
          <tr>
            <th class="text-start" i18n>Expiration date</th>
            <td>{{ simulation()?.operation?.endDate | date: 'dd/MM/yyyy'  }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  }
  <h3
    class="d-flex align-items-center gap-2"
    style="position: sticky; left: 0"
    i18n>
    Amortization table
  </h3>
  <div class="ft-card" style="width: fit-content; min-width: 100%">
    <table class="ft-table">
      <thead>
        <tr>
          <th></th>
          <th i18n>Date</th>
          <th class="text-end text-nowrap" i18n>Capital balance</th>
          <th class="text-end" i18n>Capital</th>
          <th class="text-end" i18n>Interest</th>
          <th class="text-end" i18n>Installment</th>
        </tr>
      </thead>
      <tbody>
        @for (record of simulation()?.paymentTable; track record.number) {
          <tr>
            <th class="text-start">{{ record.number }}</th>
            <td class="text-nowrap">
              {{ record.dueDate | date: 'dd/MM/yyyy' }}
            </td>
            <td class="text-end">{{ record.prinAmtBal | number }}</td>
            <td class="text-end">{{ record.prinAmt | number }}</td>
            <td class="text-end">{{ record.interest | number }}</td>
            <td class="text-end">{{ record.quotaAmount | number }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!pageCompleted()) {
    <div class="ft-table__loader" (ftObserveIntersecting)="nextPage($event)">
      <ft-progress class="ft-progress--2"></ft-progress>
    </div>
  }
</div>
